// T4 do backlog de conversao (auditoria de oferta): mecanismo minimo de A/B
// client-side, sem plataforma paga (LaunchDarkly/Optimizely seriam
// ferramenta de empresa grande demais pro tamanho deste site). Cada visitante
// e sorteado uma vez por experimento e a escolha fica salva no navegador -
// nunca muda de variante entre visitas, e o sorteio nunca quebra a pagina
// mesmo sem acesso a localStorage (aba anonima, config de privacidade).
//
// Como criar um experimento novo: adicionar uma entrada em EXPERIMENTS e
// chamar getVariant(id) na pagina. getActiveAssignments() (usado por
// analytics.js) anexa a variante de todo experimento ativo em todo evento
// disparado, automaticamente - nenhum call-site de trackEvent precisa saber
// de experimento nenhum.
const STORAGE_PREFIX = "qa_exp_";

const EXPERIMENTS = {
  // Controle: headline atual da home ("Tenha clareza..."). Variante:
  // reescrita "agressiva" proposta na auditoria de oferta, testando se uma
  // promessa mais especifica de transformacao (duvida -> aprovacao) converte
  // mais que a versao mais neutra.
  home_hero_headline: { variants: ["control", "aggressive"] },
};

function pickRandomVariant(variants) {
  return variants[Math.floor(Math.random() * variants.length)];
}

function getOverrideFromUrl(experimentId, variants) {
  try {
    const params = new URLSearchParams(window.location.search);
    const override = params.get(`exp_${experimentId}`);
    return override && variants.includes(override) ? override : null;
  } catch {
    return null;
  }
}

// Dispara "experiment_exposure" uma vez por visitante/experimento. analytics.js
// importa este arquivo, entao o import de analytics e feito de forma dinamica
// (lazy) para evitar dependencia circular na carga dos modulos.
function trackExposureOnce(experimentId, variant) {
  try {
    const flagKey = `qa_exp_exposed_${experimentId}`;
    if (window.localStorage.getItem(flagKey)) return;
    window.localStorage.setItem(flagKey, "1");
    import("./analytics")
      .then((m) => m.trackEvent("experiment_exposure", { experiment: experimentId, variant }))
      .catch(() => {});
  } catch {
    // Sem storage: nao rastreia (evita contar a cada render).
  }
}

function resolveVariant(experimentId, config) {
  const override = getOverrideFromUrl(experimentId, config.variants);
  if (override) return override;

  try {
    const stored = window.localStorage.getItem(STORAGE_PREFIX + experimentId);
    if (stored && config.variants.includes(stored)) return stored;

    const variant = pickRandomVariant(config.variants);
    window.localStorage.setItem(STORAGE_PREFIX + experimentId, variant);
    return variant;
  } catch {
    // Sem storage: sorteia sem persistir - pior caso e ver variantes
    // diferentes entre paginas na mesma visita, nunca quebra nada.
    return pickRandomVariant(config.variants);
  }
}

export function getVariant(experimentId) {
  const config = EXPERIMENTS[experimentId];
  if (!config) return "control";

  const variant = resolveVariant(experimentId, config);
  // Overrides via URL (?exp_x=variant) sao QA/preview - nao poluem a metrica.
  if (!getOverrideFromUrl(experimentId, config.variants)) {
    trackExposureOnce(experimentId, variant);
  }
  return variant;
}

// Le só o que já foi sorteado (não sorteia nada novo) - usado pra anexar a
// variante ativa nos eventos de tracking sem forçar toda página a importar
// todo experimento que existe.
export function getActiveAssignments() {
  const assignments = {};

  Object.keys(EXPERIMENTS).forEach((experimentId) => {
    try {
      const stored = window.localStorage.getItem(STORAGE_PREFIX + experimentId);
      if (stored) assignments[experimentId] = stored;
    } catch {
      // ignore
    }
  });

  return assignments;
}
